// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-tag-picker {
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--background-color,rgba(255, 255, 255, 1));
  border:  1px solid;
  border-color: rgba( 200, 200, 200 ,  1 );
  border-color: rgba( var(--palette-neutral-20,200, 200, 200) ,  1 );
  border-radius: 2px;
  padding: 1px 3px;
}
.bolt-tag-picker.edit {
  border: 1px solid rgba(0, 120, 212, 1);
  border: 1px solid var(--communication-background,rgba(0, 120, 212, 1));
  animation: ms-focus-shadow-pulse 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-tag-picker.edit {
    animation: none;
  }
}
.bolt-tag-picker.edit {
  box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.23);
  box-shadow: 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23));
}
.bolt-tag-picker:not(.edit) {
  cursor: text;
}

.bolt-tag-picker-prefix-icon {
  margin: 2px 0;
}

.bolt-tag-picker-pill {
  min-width: 0px;
  margin: 2px 4px 2px 0;
  user-select: none;
}

.bolt-tag-picker-pill-selectable:hover {
  background-color: rgba( 218, 218, 218 ,  1 );
  background-color: rgba( var(--palette-neutral-10,218, 218, 218) ,  1 );
}

.bolt-pill.standard.bolt-tag-picker-pill.bolt-tag-picker-pill-selectable.active {
  background-color: rgba( 199, 224, 244 ,  1 );
  background-color: rgba( var(--palette-primary-tint-20,199, 224, 244) ,  1 );
}

.bolt-tag-picker-add-icon-div {
  margin: 2px 0px;
}

.bolt-tag-picker-add-icon {
  border-radius: 50%;
  background-color: rgba( 239, 239, 239 ,  1 );
  background-color: rgba( var(--palette-neutral-6,239, 239, 239) ,  1 );
  padding: 4px;
}
.bolt-tag-picker-add-icon:hover {
  background-color: rgba( 218, 218, 218 ,  1 );
  background-color: rgba( var(--palette-neutral-10,218, 218, 218) ,  1 );
}

.bolt-tag-picker-callout-content {
  border-radius: 4px;
}

.bolt-tag-picker-input {
  background-color: transparent;
  border: none;
  outline: none;
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
  min-width: 120px;
  margin: 0 4px;
}
.bolt-tag-picker-input.hide-input {
  margin: 0;
  min-width: 0;
  width: 0;
}
.bolt-tag-picker-input::placeholder {
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}
.bolt-tag-picker-input:-ms-input-placeholder {
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}
.bolt-tag-picker-input::-ms-input-placeholder {
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}
.bolt-tag-picker-input::-webkit-input-placeholder {
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}
.bolt-tag-picker-input:-moz-placeholder {
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}
.bolt-tag-picker-input {
  /* clears the 'X' from Internet Explorer */
}
.bolt-tag-picker-input::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}
.bolt-tag-picker-input::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}

/*# sourceMappingURL=TagPicker.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/TagPicker/TagPicker.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/TagPicker/TagPicker.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AAIA;EACI,wCCoJc;EDnJd,gEAAA;EACA,kBAAA;EACA,wCAAA;EEHF,kEAAkE;EFKhE,kBAAA;EACI,gBAAA;AEHR;AACA;ECsCI,sCAAA;EHrCA,sEAAA;EEEF,wDCkDM;ADjDR;AACA;EFJI;IG4DI,eAAA;EDrDN;AFHE;AEKJ;EACE,6CAA6C;EAC7C,0EAA0E;AFF5E;AEIA;EACE,YAAY;AACd;;AAEA;EFAI,aAAA;AEEJ;;AAEA;EFCI,cAAA;EACI,qBC2CK;EC1CX,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,sEAAsE;AFGxE;;AEAA;EACE,4CAA4C;EFG9C,2EAAA;AEDA;;AAEA;EACE,eAAe;AFGb;;AEAJ;EACE,kBAAkB;EFIpB,4CAAA;EACI,qEAAA;EEFF,YAAY;AACd;AFIA;EACI,4CAAA;EACA,sEAAA;AEFJ;;AAEA;EFII,kBAAA;AEFJ;;AAEA;EFKQ,6BAAA;EACA,YAAA;EEHN,aAAa;EFSX,wBAAA;EACI,kDCkFS;ECzFf,gBAAgB;EFSd,aAAA;AEPJ;AACA;EFSI,SAAA;EACI,YC4ES;ECnFf,QAAQ;AFSN;AEPJ;EACE,yBAAyB;EFSvB,qDAAA;AEPJ;AACA;EFxBA,yBAAA;EAkCI,qDAAA;AEPJ;AFQI;EACI,yBAAA;EACA,qDAAA;AENR;AACA;EFQI,yBAAA;EACI,qDAAA;AENR;AACA;EACE,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA,wCAAwC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
